const Segment = 'Segment';

export const FIRE_SEGMENT_TRACK_CALL = `${Segment}/FIRE_TRACK_CALL`;
export const TEST_FIRE_SEGMENT_TRACK_CALL = `${Segment}/TEST_FIRE_TRACK_CALL`;
